import makeStyles from '@mui/styles/makeStyles';
import Avatar from "components/Matching/Avatar";
import MatchCriteria from "components/Matching/MatchCriteria";
import MatchingInfoModal from "components/MatchingInfoModal";
import {get, isEmpty, map} from 'lodash';
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {color, font, match, radius, type} from "common/tokens";

// Same stack as mentorship-droid's ClubMemberRulesDisplay: title and spot count
// on one row, the members below, then a rule divider before the group's needs.
const useStyles = makeStyles({
  panel: {
    background: match.CHIP_BG,
    border: `1px solid ${match.CARD_BORDER}`,
    borderRadius: radius.MEDIA_CARD,
    padding: 16,
    boxSizing: 'border-box',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
  },
  title: {
    ...type.sessionTitle,
    color: color.TEXT,
  },
  spots: {
    ...type.meta,
    fontWeight: font.BOLD,
    color: match.ACCENT,
  },
  avatars: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 6,
    marginTop: 10,
  },
  divider: {
    borderTop: `1px solid ${match.CARD_BORDER}`,
    marginTop: 12,
    marginBottom: 4,
  },
  label: {
    ...type.eyebrow,
    color: color.TEXT_MUTED,
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 6,
    marginTop: 6,
  },
});

const ClubMemberRuleDisplay = ({groupInfo, interesetedTrackerCount}) => {
  const classes = useStyles();
  const {t} = useTranslation();

  const groupSize = get(groupInfo, 'groupSize');
  const actualSize = get(groupInfo, 'actualSize');
  const slotsAvailable = groupSize - actualSize - interesetedTrackerCount;

  const existingMembers = get(groupInfo, 'existingMemberInfo', []);
  const clubRules = get(groupInfo, 'clubRule');
  const isSelfOnly = existingMembers.length === 1 && existingMembers[0].id === '';

  const [partner, setPartner] = useState(null);

  return (
    <div className={classes.panel}>
      <div className={classes.header}>
        <div className={classes.title}>{t('yourGroup')}</div>
        <div className={classes.spots}>{`${slotsAvailable}/${groupSize} ${t('spotsAvailable')}`}</div>
      </div>

      {!isEmpty(existingMembers) && !isSelfOnly && (
        <div className={classes.avatars}>
          {map(existingMembers, member => member.id !== '' && (
            <Avatar key={member.id} size={30} fontSize={11} displayName={member.fullName}
                    displayPicture={member.displayPicture}
                    onClick={() => setPartner(member)}/>
          ))}
        </div>
      )}

      {!isEmpty(clubRules) && (
        <>
          <div className={classes.divider}/>
          <div className={classes.label}>{t('mentorshipGroupNeeds')}</div>
          <div className={classes.chips}>
            {map(clubRules, (rule, key) => map(rule.answer, answer => (
              <MatchCriteria key={`${key}-${answer}`} criteria={answer} icon={rule.icon} onTint
                             status={MatchCriteria.criteriaStatus.ACTIVE}/>
            )))}
          </div>
        </>
      )}

      {partner && <MatchingInfoModal open handleClose={() => setPartner(null)} matchId={partner.id}
                                     fullName={partner.fullName}/>}
    </div>
  );
};

export default ClubMemberRuleDisplay;
